import { DangerousGoodsDefinitionDto, TemperatureUnit } from '@planning/app/api'

export interface DangerousGoodsDefinitionFormProfile {
  id?: number
  unNumber: string
  material: string
  primaryImoClass: string
  secondaryImoClasses: string[]
  packingGroup?: string
  flashPoint?: number
  flashPointUnit?: TemperatureUnit
  isMarinePollutant?: boolean
  handlingNotes?: string
}

export const defaultValues: DangerousGoodsDefinitionFormProfile = {
  unNumber: '',
  material: '',
  primaryImoClass: '',
  secondaryImoClasses: [],
  packingGroup: undefined,
  flashPoint: undefined,
  flashPointUnit: undefined,
  isMarinePollutant: undefined,
  handlingNotes: '',
}

export const mapDangerousGoodsDefinitionDtoToDangerousGoodsDefinitionFormProfile = (
  {
    id,
    unNumber,
    material,
    primaryImoClass,
    secondaryImoClasses,
    packingGroup,
    flashPoint,
    isMarinePollutant,
    handlingNotes,
  }: DangerousGoodsDefinitionDto,
  defaultTemperatureUnit?: TemperatureUnit,
): DangerousGoodsDefinitionFormProfile => ({
  id,
  unNumber: unNumber ?? '',
  material: material ?? '',
  primaryImoClass: primaryImoClass ?? '',
  secondaryImoClasses: secondaryImoClasses ?? [],
  packingGroup: packingGroup ?? undefined,
  flashPoint: flashPoint?.value ?? undefined,
  flashPointUnit: flashPoint?.value ? flashPoint?.unit : defaultTemperatureUnit,
  isMarinePollutant: isMarinePollutant ?? undefined,
  handlingNotes: handlingNotes ?? undefined,
})
